import { render, staticRenderFns } from "./ManagePeriod.vue?vue&type=template&id=6e13357f&"
import script from "./ManagePeriod.vue?vue&type=script&lang=js&"
export * from "./ManagePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports